module.exports = __webpack_public_path__ + "assets/img/6_458_big.794b2e27.jpg";